import getJsonFromScriptTag from 'DOM/getJsonFromScriptTag';
import pickOne from 'pickoneitem';

const selectors = {
  dropdown: '.prettydropdown',
  heroSide: '[data-hero-side]',
  homepageHero: '[data-homepage-hero]',
  homepageHeroOption: '[data-homepage-hero] .prettydropdown li',
  imagesLeft: '.left-side .homepage-hero__image',
  imagesRight: '.right-side .homepage-hero__image',
  listbox: '.prettydropdown ul',
};

const state = {
  currentVariant: null,
};

const getHeroImageGroup = (parent) => {
  const key = parent.getAttribute('data-hero-side');
  return state[key];
};

const handleOptionChange = (id, parent) => {
  const { productData } = state;
  const variantTitle = productData[id];

  if (variantTitle.indexOf('mg') < 0) return;
  const selector = `[data-variant-options*="${variantTitle}"]`;
  const group = getHeroImageGroup(parent);
  group.pick(selector);
}

const handleOptionClick = (event) => {
  const option = event.target.closest(selectors.homepageHeroOption);

  if (!option) return;

  const { value } = option.dataset;
  const parent = option.closest(selectors.heroSide);
  if (state.currentVariant !== value) {
    state.currentVariant = value;
    handleOptionChange(value, parent);
  }
};

const addEventListeners = () => {
  const homepageHero = document.querySelector(selectors.homepageHero);

  if (!homepageHero) return;

  state.productData = getJsonFromScriptTag('[data-hero-collection]');
  document.addEventListener('click', handleOptionClick);
}

const assignPickOneGroups = () => {
  const leftGroup = pickOne();
  leftGroup.init({
    className: 'hide',
    group: selectors.imagesLeft,
    invert: true,
  });
  state['left-side'] = leftGroup;

  const rightGroup = pickOne();
  rightGroup.init({
    className: 'hide',
    group: selectors.imagesRight,
    invert: true,
  });
  state['right-side'] = rightGroup;
}

const homepageHero = {
  init: () => {
    addEventListeners();
    assignPickOneGroups();
  },
}

homepageHero.init();
